import {
  KYB_STATUSES,
  KYB_STATUS_VALUES,
} from '@/shared/constants/store-constants/account'

function normalizeKybStatus(raw) {
  const value = String(raw ?? '').toLowerCase()
  return KYB_STATUS_VALUES.includes(value) ? value : KYB_STATUSES.UNSPECIFIED
}

export default {
  SET_REQUISITES(state, payload) {
    state.requisites = payload
    state.isLoaded = true
  },

  SET_LOADING(state, value) {
    state.isLoading = value
  },

  SET_KYB_STATUS(state, payload) {
    state.kybStatus = normalizeKybStatus(payload?.status)
    state.kybStatusUpdatedAt = payload?.updated_at ?? null
    state.isKybStatusLoaded = true
  },

  SET_KYB_STATUS_LOADING(state, value) {
    state.isKybStatusLoading = value
  },

  RESET_ACCOUNT(state) {
    state.requisites = null
    state.isLoading = false
    state.isLoaded = false

    state.kybStatus = KYB_STATUSES.UNSPECIFIED
    state.kybStatusUpdatedAt = null
    state.isKybStatusLoading = false
    state.isKybStatusLoaded = false
  },
}
